import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import type { CoachingConfig } from '@efdigital/ll-addon-data/types/coaching/coaching-config';
import { findCoachingConfig } from '@efdigital/ll-admin-v2/data/builders/xceed/coaching-configs';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

type Params = { coaching_config_id: string };

export type CoachingConfigsConfigModel = {
  coachingConfig: CoachingConfig;
};

export default class CoachingConfigsConfigRoute extends Route<CoachingConfigsConfigModel> {
  @service declare store: Store;

  async model(params: Params) {
    const coachingConfig =
      params.coaching_config_id === 'new'
        ? this.store.createRecord<CoachingConfig>(
            DataTypeCoaching.CoachingConfig,
            {
              name: '',
              coachingTimeMinutes: 480,
              allowedSessionDurations: [30, 45, 60, 75, 90],
              defaultSessionDurationMinutes: 60,
              chemistrySessionLengthMins: 30,
              cancellationWindowHours: 48,
              schedulingWindowDays: 30,
              chemistryCallLimit: 3,
              coachConfirmationHoursAfterBookingChemistry: 48,
              coachConfirmationHoursAfterBookingCoaching: 0,
              coachConfirmationHoursBeforeStart: 8,
            }
          )
        : (
            await this.store.request(
              findCoachingConfig(params.coaching_config_id)
            )
          ).content.data;

    return { coachingConfig };
  }
}
